export type AbilitiesActions = 'view' | 'create' | 'edit' | 'delete';

export enum AbilitiesPermissions {
  None = 0,
  View = 1,
  Edit = 2,
  Create = 4,
  Delete = 8,
}

export type Resource =
  | 'client'
  | 'vessel'
  | 'referral'
  | 'assignment'
  | 'transaction'
  | 'balance'
  | 'financial'
  | 'settings'
  | 'task';

export type ResourceFilters =
  | 'client.client'
  | 'client.partner'
  | 'client.supplier'
  | 'assignment.activeAssignment'
  | 'transactions.assignments';

export type ResourceScopes = 'balance.all' | 'balance.own' | 'task.all' | 'task.own';
export type PermissionKey = Resource | ResourceFilters | ResourceScopes;
export type RolePermissions = Partial<Record<PermissionKey, number>>;
export type PermissionsByRole = Record<string, RolePermissions>;
export type ResourceScopeOperator =
  | 'eq'
  | 'ne'
  | 'in'
  | 'notIn'
  | 'contains'
  | 'startsWith'
  | 'endsWith'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'null';
export type ResourceScopeLookup = {
  select: string;
  query: ResourceScopeQuery;
};
export type ResourceScopeQuery = Record<
  string,
  | HierarchyQueryValue
  | ResourceScopeQuery[]
  | Partial<Record<ResourceScopeOperator, HierarchyQueryValue | ResourceScopeLookup>>
>;
export type ResourceScope = { query?: ResourceScopeQuery };
export type ScopedAction = { scopes: string[] };
export type ResourceAction = ResourceDependency[] | ScopedAction;

export type HierarchyQueryValue = string | number | boolean | string[];

export type HierarchyQuery = Record<string, Record<string, HierarchyQueryValue>>;

export type ResourceDependency = { resource: Resource; action: AbilitiesPermissions };

export type ResourceFilter = {
  label: string;
  value: string;
  query?: HierarchyQuery;
  protected?: boolean;
  resource?: string;
};

export type ResourceHierarchy = Record<
  Resource,
  {
    view?: ResourceAction;
    create?: ResourceAction;
    edit?: ResourceAction;
    delete?: ResourceAction;
    scopes?: Record<string, ResourceScope>;
    query?: HierarchyQuery;
    protected?: boolean;
    resource?: string;
    children?: Record<string, ResourceHierarchy[keyof ResourceHierarchy]>;
    filters?: ResourceFilter[];
  }
>;

export type ReadWritePermission = 'Read' | 'Write' | 'None';

export type ReadWritePermissions = Record<
  Resource,
  {
    permissions: ReadWritePermission[];
    filters?: ResourceFilter[];
  }
>;
